import { BtvProgramme, VodEditorial } from 'services/data-manager/types';

import getDeeplinkItem from 'utils/getDeeplinkItem';
import isValidDeeplinkItem from 'utils/isValidDeeplinkItem';

function getRBAssetChannelId(asset: VodEditorial | BtvProgramme) {
    let channelId = (asset as BtvProgramme).serviceRef;

    if (!channelId) {
        const deeplink = getDeeplinkItem(asset);

        if (deeplink && isValidDeeplinkItem(deeplink)) {
            channelId = deeplink.provider;
        }
    }

    return channelId;
}

export default getRBAssetChannelId;
